/***************************************************************************************************************************************/
$.cachedScript = function(url, options) {
	"use strict";
	options = $.extend(options || {}, {
    	dataType: "script",
    	cache: true,
    	url: url
  	});
  	return jQuery.ajax(options);
};


function setCookie(name, value , days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    }
    document.cookie = name+"="+value+expires+"; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length,c.length);
        }
    }
    return null;
}

function eraseCookie(name) {
    setCookie(name,"",-1);
}

var Cookie = {
	initCookies:function($target,cookie){

		var $google = $('input.checkbox-toggle-input.checkbox-toggle-input-google');
		var $marketing = $('input.checkbox-toggle-input.checkbox-toggle-input-marketing');

		if(getCookie('google') === null){
			$google.prop('checked',false);
			$google.removeClass('checked');		
			$('#ccc').addClass('open');
			$("body").addClass('cookie-overlay-showing');
		}
		
		if(getCookie('google') == 'true'){											
			$google.prop('checked',true);
			$google.addClass('checked');			
		}else{				
			$google.prop('checked',false);
			$google.removeClass('checked');			
		}

		if(getCookie('marketing')=='true'){				
			$marketing.prop('checked',true);
			$marketing.addClass('checked');
		}else{
			$marketing.prop('checked',false);
			$marketing.removeClass('checked');
		}
	},

	toggleCookies:function($target,cookie){
		var $google = $('input.checkbox-toggle-input.checkbox-toggle-input-google');
		var $marketing = $('input.checkbox-toggle-input.checkbox-toggle-input-marketing');
		setCookie(cookie,$target.is(':checked'),365);		
		
		if(getCookie('google') == 'true'){															
			$google.addClass('checked');
			$('#ccc-optional-categories .ccc-alert').removeClass('visible');
		}else{								
			$google.removeClass('checked');
			$('#ccc-optional-categories .ccc-alert').addClass('visible');
		}		

		if(getCookie('marketing')=='true'){								
			$marketing.addClass('checked');

		}else{
			$marketing.removeClass('checked');
		}		
	},

	recomendedCookies :function(){
		var $google = $('input.checkbox-toggle-input.checkbox-toggle-input-google');			
		setCookie('google',true,365);		
		$google.prop('checked',true);
		$google.addClass('checked');						
		setTimeout(function(){
			location.reload();
		},500);	
	}		
};

var first_time=true;
var fragged = location.href;
var fragments = fragged.split('?_escaped_fragment_=%2F');
if (fragments.length >= 2){
    var unfragged = fragments[0] + '#!/' + fragments[1];
    window.location = unfragged;

}


$(window).load(function () {
	"use strict";
	
	setTimeout(function () {
		$('#content_wrapper').removeClass("loading");
		$('#content_wrapper').addClass('loaded');
		
		$('#content_wrapper #main_wrapper').animate({
			opacity: 1
		}, 200);
		
		setHeights();

		if($('#products').length>0){
			var $_url =  window.location.href.split('#!');
			if($_url.length>1 && $('[href="'+WS_ROOT+COUNTRY_CODE+'/'+LANGUAGE_CODE+'/ajax'+$_url[1]+'/"]').length>0){
				$('[href="'+WS_ROOT+COUNTRY_CODE+'/'+LANGUAGE_CODE+'/ajax'+$_url[1]+'/"]').trigger('click');
			}
		}

		if($('#sustainability').length>0){
			setTimeout(function(){ 
				$('.topbar').removeClass('hidden-position');
				$('.topbar').removeClass('hidden-content');
			}, 300);
		}

	  if (window.location.hash) {
		  var target = location.hash.split('#');
		  setTimeout(function() {
			window.scrollTo(0, 0);
		  }, 10);
		}
	   if (window.location.hash) {
	      var anchorpage = location.hash.split('#');
		  setTimeout(function () {
		  	$('html, body').animate({
				'scrollTop':   $('#'+anchorpage[1]).offset().top - 300
			}, 500);
		  }, 500);
	    }

    //  equalizeHeight('eq-height');
	//	equalizeHeight('post-eq-height');
    //  equalizeHeight('nav-eq-height');
	//	equalizeHeight('grid-eq-height');
	//	equalizeHeight('catgrid-eq-height','max');
	//	$( window ).trigger("resize");
		
	}, 100);	
});

$(function() {
	'use strict';
	
	$('[id]').each(function(){
		var ids = $('[id="'+this.id+'"]');
				
	});
	
	$('.select2').select2();


	$('[data-plg="slick"]').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  infinite: true,
	   autoplay: true,
       autoplaySpeed: 4000,
	  speed: 500,
	  fade: true,
	  cssEase: 'linear'
	});

	if( $(".homevideo-banners").length>0 && $(window).width() > 991){
		$(".homevideo-banners").mousemove(function (e) {
			var x = e.pageX - $(this).offset().left - 40;
		    var y = e.pageY - $(this).offset().top - 40;
			$('#moving-video-link').css({transform:'translate('+x+'px, '+y+'px)', left: 'auto',top: 'auto'});				
			
	    }).mouseleave(function (e) {
		    	 $('#moving-video-link').css({
		    	 	transform:'translate(-50%,-50%)',
			        left: '50%',
			        top: '50%'
			    });
	    });
	}

     


	
	$('.back-btn').click(function(){
		
		$('.responsive-nav .trigger').parent().removeClass('open');

		if($('.show-lvl-3').length>0){
			$('.technical-fabrics-category').fadeOut(500);
			$('div[class*="packaging-solutions-category"]').hide();	
			$('div[class*="technical-fabrics-category"]').hide();
			setTimeout(function(){ 
				$('.show-lvl-3').show();
				$('.show-lvl-3').removeClass('show-lvl-3');					
			}, 500);
		}else{
			$('.show-lvl-2').removeClass('show-lvl-2');
			setTimeout(function(){ 
				$('.main-nav .nav.navbar-nav.navbar-right').show();
			}, 500);
			setTimeout(function(){ 
				$('.responsive-nav').removeClass('hide-first-lvl');
			}, 550);
		}

		return false;
	});

	$('.waypoint').waypoint(function(direction) {
        var el = $(this.element);
        if(el.data('wpclass')){
            el.addClass(el.data('wpclass'));
        }else{
            el.addClass('shown');    
        }
        
    }, {
      offset: '85%'
    });

	$(".fancybox-trigger").fancybox({
		animationEffect: "zoom-in-out"
	});




	$('.slick-carousel').each(function(){
		$(this).slick({
		slidesToShow: 1, 
		slidesToScroll: 1,
		dots: false,
		 pauseOnHover:false ,
		 pauseOnFocus:false ,
		 speed: 500, 
		 fade: true, 
		 arrows: false,
		 cssEase: "linear",
		 autoplay: true, 
		 autoplaySpeed: 3000
		});
		$(this).on( 'touchend touchcancel touchmove', function() { $(this).slick('slickPlay'); } );
	});

	$('.responsive-nav .navbar-nav li .trigger.trigger-lvl-1').click(function(e){
		var $this = $(this);
		var $target = $this.data('target');
		$('.responsive-nav').addClass('hide-first-lvl');
		$this.parent().addClass('open');
		setTimeout(function(){ 
			$('.main-nav .nav.navbar-nav.navbar-right').hide();				
			$('.megamenu.'+$target).addClass('show-lvl-2');	
		}, 500);
		e.preventDefault();
	});


	$('.responsive-nav .trigger.trigger-lvl-2').click(function(e){
		var $this = $(this);
		var $target = $this.data('target');						
		$this.closest('.lvl-2-links').addClass('show-lvl-3');			
		setTimeout(function(){ 

		}, 500);
		e.preventDefault();
	});

	$('.packaging-solutions-list li a').on('click',function(){
		if($(this).hasClass('active')) {return false;}
		$('.packaging-solutions-list li a.active').removeClass('active');
		$(this).addClass('active');
		var selected = $(this).data('id');

		$('div[class*="packaging-solutions-category"]').hide();
		setTimeout(function(){
			$('.mm-packaging-solutions .lvl-2-links').hide();
			$('.packaging-solutions-category-'+selected).fadeIn('slow');
		},500);
		return false;
	});

	$('.technical-fabrics-list li a').on('click',function(){

		if($(this).hasClass('active')) {return false;}
		$('.technical-fabrics-list li a.active').removeClass('active');
		$(this).addClass('active');
		var selected = $(this).data('id');

		$('div[class*="technical-fabrics-category"]').hide();
		setTimeout(function(){
			$('.mm-technical-fabrics .lvl-2-links').hide();
			$('.technical-fabrics-category-'+selected).fadeIn('slow');	
		},500);
		return false;
	});
	$(".responsive-nav").mCustomScrollbar({
		theme:"dark"
	});
	
	$('.navbar-toggle').on('click',function(e){
		if($('body').hasClass('open-nav')){
			closeResponsiveNav();
		}else{
			$('body').addClass('open-nav');	
		}
		
		e.preventDefault();
	});
	
	
	$('.btn-top').on('click',function(){
		$('html, body').stop().animate({scrollTop: 0}, 800);
	});
	
	$('.btn-more').on('click',function(){
		if(!$(this).hasClass('disabled')){
			more($(this));
		}
		return false;
	});
	
	$('.print-trigger').on('click',function(){
		var url = $(this).attr('href');
		$('body').append('<iframe src="'+url+'" style="display:none"/>');
		return false;
	});
	
	$('.companies-list li a').on('click',function(){
		if($(this).hasClass('active')){return false;} 
		$('.companies-list li a.active').removeClass('active');
		$(this).addClass('active');
		var selected = $(this).attr('rel');
		
		$('div[class*="company"]').hide();
		$('.company_'+selected).fadeIn('fast');
		
		return false;
	});	
	$('.btn-more').on('click',function(){
		if(!$(this).hasClass('disabled')){
			more($(this));
		}
		return false;
	});
	
	$('.mm_tab_item').on('click',function(){
		changeTab($(this));
	});
	
	$('.filter_type a.btn-link').on('click',function(){
		var selection = $(this).attr('rel');
		var target = $(this).parent().parent().attr('rel');
		$(this).parent().find('.active').removeClass('active');
		$(this).addClass('active');
		$('form[name="'+target+'-nav"] input[name="type"]').val(selection);
		filter(target);
	});
	
	$('.filter_year > a.btn-link').on('click',function(){
		if($(this).parent().hasClass('active')){
			return false;	
		}
		
		var selection = $(this).attr('rel');
		var target = $(this).parent().attr('rel');
		$(this).parent().parent().find('.active').removeClass('active');
		$(this).parent().addClass('active');
		$('form[name="'+target+'-nav"] input[name="year"]').val(selection);
		filter_list(target);
	});

	
	
	/*$.cookieBar( {
		element: 		'body',
		zindex: 		'999',
		message: 		POLICY_TEXT,
		acceptText: 	ACCEPT_TEXT,
		
		policyButton: 	true,						
		policyText: 	SETTINGS_TEXT,
		policyURL: 		"#",
		fixed: 			true,
		bottom: 		true,
		domain: 		URL,
		referrer: 		URL
	} );*/
	
	
	$.history.init(function(url){
    	if (url !== ''){
            if(url === '!'){
                $.fancybox.close();
            }
            var c_url = url.replace('!', '');
			c_url = c_url.replace('/', '');
			if (first_time === true && c_url !== ''){
				var popup_url = parseHashUrl(c_url);
				
				if(popup_url!==''){
					$('#modal').modal({show:true,remote:popup_url,shown:onModalOpen,hidden:onModalClose});
				}
			}
        }
    },{unescape: "/,&"});
	
	var threshold = 125;
	if($(window).scrollTop() > threshold) {
		$('.toplinks').addClass('sticky'); 
		$(".header").addClass("sticky");
	}
	
	if($(window).scrollTop() > 175){
		$(".breadcrumb-container").addClass("sticky");
	}

	$(document).on('scroll',function() { 

		if($(window).scrollTop() > threshold) {
			$('.toplinks').addClass('sticky'); 
			$('.header').addClass('sticky');
		}else if( $('.header').hasClass('sticky') && $('body#statuspage').length == 0 && $('body#showrooms').length == 0 ){
			$('.toplinks').removeClass('sticky');
			$('.header').removeClass('sticky'); 
		}
		
		if($(window).scrollTop() > 175){
			$(".breadcrumb-container").addClass("sticky");
		}else if( $('.breadcrumb-container').hasClass('sticky')){
			$(".breadcrumb-container").removeClass("sticky");		
		}

	});
	

	$(document).on('click', ".ajax-modal", function (e) {
		try{
			$('body').append('<div class="modal fade" id="'+ $(this).data('modal')+'" role="dialog"></div>');
			onModalOpen();
			
			if(typeof ($(this).attr("href"))!=="undefined"){
				openAjaxModal($(this).attr('href'), $('#'+ $(this).data('modal')));				
			}else{
				openAjaxModal($(this).data('href'), $('#'+ $(this).data('modal')));
			}
			e.preventDefault();
        }catch(Error){
            console.log(Error);
        }
        return false;
    });

    $(document).on('click', ".toggle-modal", function (e) {
		try{
			var $target = $(this).data('target');
			var $m_markup=$('#'+$target).html();
			$($m_markup).find('div.modal-dialog').removeClass('hidden');
			$('body').append('<div class="modal fade" id="'+ $target+'-modal" role="dialog"><div class="container">'+$m_markup+'</div></div>');
			onModalOpen();
					
	        $('#'+$target+'-modal').modal('show');
	        $('#'+$target+'-modal select' ).select2();
	        callbacks('#'+$target+'-modal');

	          $('#'+$target+'-modal').on('hidden.bs.modal', function () {
	             $('#'+$target+'-modal').remove();
	        });
		   
			e.preventDefault();
        }catch(Error){
            console.log(Error);
        }
        return false;
    });




    $(document).on('click', ".append-product-finder-block", function (e) {
    	var href = $(this).attr('href');
		try{
			if($(this).hasClass('active')){
				$(this).removeClass('active');
				$('body').removeClass('product-finder-open');
				 $("#product-finder-wrapper").slideUp('fast', function() {
				 	//$('#product-finder-wrapper').remove();
				 });
				
			}else{
				$(this).addClass('active');
				$('body').addClass('product-finder-open');
				$('.breadcrumb-container').append('<div id="product-finder-wrapper" style="display:none;"></div>');
				 $('#product-finder-wrapper').load(href,function(){
			        callbacks('#product-finder-wrapper');
			       	$('.select2').select2();
			        $("#product-finder-wrapper").slideDown('fast');
			    });
			}
			e.preventDefault();
        }catch(Error){
            console.log(Error);
        }
        return false;
    });
      $(document).on('click', ".close-product-finder", function (e) {
      	 $("#product-finder-wrapper").slideUp('fast', function() {
		 	//$('#product-finder-wrapper').remove();
		 });
    	$('body').removeClass('product-finder-open');
		$('.append-product-finder-block').removeClass('active');
        return false;
    });
    
   
	
	$(document).on('click', ".modal .close", function () {
		try{
			onModalClose();
		}catch(Error){
            console.log(Error);
        }
	});	

	 callbacks( );


});

var rtime = new Date();
var timeout = false;
var delta = 300;
$(window).resize(function() {
	"use strict";
	rtime = new Date();
    if (timeout === false) {
        timeout = true;
        setTimeout(resizeend, delta);
    }
});

function closeResponsiveNav(){
	"use strict";
	$('body').removeClass('open-nav');	
	$('.technical-fabrics-category').fadeOut(500);
	$('div[class*="packaging-solutions-category"]').hide();	
	$('div[class*="technical-fabrics-category"]').hide();
	setTimeout(function(){ 
		$('.show-lvl-3').show();
		$('.show-lvl-3').removeClass('show-lvl-3');					
	}, 500);

	$('.show-lvl-2').removeClass('show-lvl-2');
	setTimeout(function(){ 
		$('.main-nav .nav.navbar-nav.navbar-right').show();
	}, 500);
	setTimeout(function(){ 
		$('.responsive-nav').removeClass('hide-first-lvl');
	}, 550);
}
function resizeend() {
	"use strict";
    if (new Date() - rtime < delta) {
        setTimeout(resizeend, delta);
    } else {
        timeout = false;
		//equalizeHeight('eq-height');
		//equalizeHeight('nav-eq-height');
		//equalizeHeight('grid-eq-height');
		//equalizeHeight('catgrid-eq-height','max');
        setHeights();
    }               
}
function filter(target){
	"use strict";
	$('form[name="'+target+'-nav"] input[name="page"]').val(0);
	itemsOut();
	 setTimeout(function(){
		$.ajax({data:$('form[name="'+target+'-nav"]').serialize(),dataType:'html',success:function(data){
			var classes = $('#'+target+'-grid > ul').attr('class');
			$('#'+target+'-grid').replaceWith(data);
			$('#'+target+'-grid > ul').attr('class',classes);
			itemsIn();
		}});
	 },200);
}
function filter_list(target){
	"use strict";
	$('form[name="'+target+'-nav"] input[name="page"]').val(0);
	$.ajax({data:$('form[name="'+target+'-nav"]').serialize(),dataType:'html',success:function(data){
		$('#'+target+'-list').fadeOut('fast',function(){
			$(this).html(data).fadeIn('fast');
		});
	}});
}
function itemsOut(){
	"use strict";
	$('.grid_item').each(function(){
		var newX = 0;
		var newY = 60;
		$(this).css({
			'-moz-transform' : 'translate('+ newX +'px,'+ newY +'px)',
			'-webkit-transform' : 'translate('+  newX +'px,'+ newY +'px)',
			'-webkit-transition' : 'all 0.5s',
			'opacity' : '0'
		});
	});
}
function itemsIn(){
	"use strict";
	$('.grid_item').each(function(){
		var newX = 0;
		var newY = 60;
		$(this).css({
			'-moz-transform' : 'translate('+ newX +'px,'+ newY +'px)',
			'-webkit-transform' : 'translate('+  newX +'px,'+ newY +'px)',
			'opacity' : '0'
		});
	});
	
	setTimeout(function(){
		$('.grid_item').each(function(){
			var newX = 0;
			var newY = 0;
			$(this).css({
				'-moz-transform' : 'translate('+ newX +'px,'+ newY +'px)',
				'-webkit-transform' : 'translate('+  newX +'px,'+ newY +'px)',
				'-moz-transition' : 'all 0.5s',
				'-webkit-transition' : 'all 0.5s',
				'opacity' : '1'
			});
		});
	},200);
}
function equalizeHeight(target, height){
		
	if($('.'+ target).length>0 || typeof target !== undefined){
		
		$('.'+ target).each(function(){
			$('.'+ target).addClass('autoHeight');
			$('.'+ target).css('min-height','auto');
			if($('.'+ target).parent().hasClass('card')){
				$('.'+ target).css('height','auto');
			}
		});

		var padding = 0;
		if(target === "grid-eq-height"){padding = 10;}

		var min_height = 0;
		setTimeout(function(){
			$('.'+ target).each(function(){
				if($(this).innerHeight()+padding > min_height){
					min_height = $(this).innerHeight()+padding;
				}
			});
			if(min_height>0){

				if(height=='max'){
					$('.'+ target).css('max-height',min_height);
					$('.'+ target).css('min-height',min_height);
				}else{
					$('.'+ target).css('min-height',min_height);
				}
				
				
				if($('.'+ target).parent().hasClass('card')){
					$('.'+ target).css('height',min_height);
				}
			}
			$('.'+ target).each(function(){			 
				$('.'+ target).removeClass('autoHeight');
			});

		},200);
	}	
}
function randomMinToMax(min, max_v) {
	"use strict";
	var range = max_v - min + 1;
	return Math.floor(Math.random()*range + min);
}
function more(t){
	"use strict";
	var target = t.attr('rel');
	t.addClass('loading disabled');
	var next_page = Number($('form[name="'+target+'-nav"] input[name="page"]').val()) + 1;
	$('form[name="'+target+'-nav"] input[name="page"]').val(next_page);
	$.ajax({data:$('form[name="'+target+'-nav"]').serialize(),dataType:'html',success:function(data){
		t.removeClass('loading disabled');
		$('#'+target+'-list').append(data);
	}});
}
function changeTab(t){
	"use strict";
	var p = t.parent(),
	at = p.find('.mm_tab_active'),
	ac = at.find('.tab_content_wrapper,.rowtab_content_wrapper'),
	c = t.find('.tab_content_wrapper,.rowtab_content_wrapper');	
	if (!t.hasClass('mm_tab_active')){
		ac.fadeOut('slow');
		c.fadeIn('slow');
		at.removeClass('mm_tab_active');
		t.addClass('mm_tab_active');
	}
}
function onModalOpen(){
	"use strict";
	var clipboard = new Clipboard('.clipboardButton');	
	clipboard.on('success', function(e) {
		console.info('Action:', e.action);
		console.info('Text:', e.text);
		console.info('Trigger:', e.trigger);
		
		$('.clipboardButton .copy-label').text(' copied!');
		
		e.clearSelection();
	});
	clipboard.on('error', function(e) {
		console.error('Action:', e.action);
		console.error('Trigger:', e.trigger);
	});

	setTimeout(function(){
		var hash 		= $('#modal .meta').data('hash'),
			title 		= $('#modal .meta').data('title'),
			description = $('#modal .meta').data('description'),
			image 		= $('#modal .meta').data('image'),
			url 		= encodeURIComponent($('#modal .meta').data('url')),
			print_url	= $('#modal .meta').data('printUrl');
			

		var bread = $('.container .breadcrumb').html();
		
		var s = '';
		s += ' <a class="print-trigger" href="'+print_url+'" target="_blank" style="text-decoration:none;"><i class="fa fa-print" style="font-size:20px"></i></a>';
		
		if(hash){
			window.location.hash = hash;
		}
	
		$('.modal-header .social-media-links').html(s);
		$('.modal-body .breadcrumb').html(bread);
		$('.modal-body .breadcrumb li:eq(0)').remove();
		//$('.modal-body .breadcrumb li:eq(0)').remove();
		//$('.modal-body .breadcrumb li').removeClass('active');
		$('.modal-body .breadcrumb li.last-child').remove();	
	}, 200);
}
function onModalClose(){
	"use strict";
	window.location.hash = '';
	$('#modal .meta').empty();
	$('#modal .modal-body').empty();
}
function parseHashUrl(url){
	"use strict";
	var element = url.replace('/', '').split(':');
	if(element.length === 2 && element[0]!=='products'){
		return (element.length === 2)?URL+'ajax/' + element[0] + ':popup/' + element[1]:'';
	}else if(element.length === 2 && element[0]==='products'){
		return (element.length === 2)?URL+'ajax/' + element[0] + ':popup/' + element[1]:'';
	}else{
		return '';
	}
}
function initNewsletterForm(){
	"use strict";	
    $('form[name="join_newsletter"]').validate({
        errorPlacement: function(error) {
            error.hide();
        },
        submitHandler: function() {
            $.ajax({data:$('form[name="join_newsletter"]').serialize(),success:function(data){
                if(data.status === "ok"){
                    $('form[name="join_newsletter"] input:text').val("");

                    alert(data.message);
                }else if(data.status === 'error') {
                    alert(data.error);
                }else{
                    alert('An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
function registerGAEvent(title,content){
    "use strict";
    if(typeof(gtag)!=='undefined'){
        gtag( 'event', content.replace(/ /g, "_")+'_'+title , {
		  	   'event_category': content,
		  	   'event_label': title,
		});

         
    }
}
function setHeights(){
	'use strict';
	
	var container  = $('.header .container-large');
	var megamenuTF = $('.header .megamenu.tf');
	var megamenuPS = $('.header .megamenu.ps');
	
	if( container.length>0 && megamenuTF.length>0 && megamenuPS.length>0 ){	
		
		var containerWidth = container.innerWidth();
		var containerEdge = container.offset();


		megamenuTF.css('left', '0px');	
		var megamenuTFEdge = megamenuTF.offset();
		var moveTF = containerEdge.left - megamenuTFEdge.left;
		megamenuTF.css('left', moveTF+'px');
		megamenuTF.css('width', containerWidth+'px');	

		megamenuPS.css('left', '0px');
		var megamenuPSEdge = megamenuPS.offset();
		var movePS = containerEdge.left - megamenuPSEdge.left;
		megamenuPS.css('left', movePS+'px');
		megamenuPS.css('width', containerWidth+'px');

	}

	if($('.skype_btn img')){
		$('.skype_btn img').css("margin",0);
		$('.skype_btn img').css("vertical-align","-12px");
		$('.skype_btn p').css("float","left");
		$('.skype_btn p').css("margin-left","10px");
	}
}
function openAjaxModal(href,$m){
    'use strict';
	$m.removeData('bs.modal');
    $m.empty();
    $m.load(href,function(){
        $m.modal('show');
        callbacks('#'+$m.attr('id'));

         $m.on('hidden.bs.modal', function () {
            $m.remove();
        });
    });
}

function callbacks( c ) {
    var container = c || '';
   //ajaxContent( container + ' .ajax-content' );

    $( container + ' .callbacks' ).each( function( ) {
        if ( !$( this ).hasClass( 'callbacks-executed' ) ) {
            if ( container !== '' || !$( this ).hasClass( 'callbacks-executed' ) ) {
                var c = $( this ).data( );
                for ( var i in c ) {
                    if ( i.indexOf( 'fn' ) === 0 && c[ i ] !== '' ) {
                        var fn = c[ i ];
                        var params = c[ 'params' + i ] || null;

                        try {
                            if ( c[ 'after' + i ] && typeof( window[ c[ 'after' + i ] ] ) === 'function' ) {

                                var callbackAfter = c[ 'after' + i ];
                                var callbackAfterParams = c[ 'after' + i + 'Params' ] || null;

                                window[ fn ]( params, function( ) {
                                    window[ callbackAfter ]( callbackAfterParams );
                                } );
                            } else {
                                window[ fn ]( params );
                            }
                            $( this ).addClass( 'callbacks-executed' );
                        } catch ( Error ) {
                            console.log( Error + ' ' + fn );
                        }
                    }
                }
            }
        }
    } );

}


function initHomeFeatured(href,$m){
    'use strict';
	
	var homeFeaturedtffeatured = $('.recommendations .carousel #tffeatured');	
	var homeFeaturedpffeatured = $('.recommendations .carousel #pffeatured');
	var options = {
		autoplaySpeed: 5000,
		lazyLoad: "progressive",
		speed: 600,
		arrows: true,		
		prevArrow:'<span class="slick-arrow prev slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225   c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/></svg></span>',
		nextArrow:'<span class="slick-arrow next slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z   "/></svg></span>',
		slidesToShow: 4,
		slidesToScroll: 4,
		dots: false,
		infinite: true,
		pauseOnHover: false,
		adaptiveHeight: false,
		cssEase: "cubic-bezier(0.87, 0.03, 0.41, 0.9)",
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
		
	};
	homeFeaturedtffeatured.slick( options );
	homeFeaturedpffeatured.slick( options );
}

function homeSearch() {
	 $('#form-search').on('keydown',function(e){
	 	 switch(true){
            case e.keyCode == 13:
            	e.preventDefault();
            	var $search_val = $(this).find('.search--input').val();
            	$('#morphsearch').find('.morphsearch-input').val($search_val);
            	$('#morphsearch').find('.morphsearch-submit').trigger('click');
            	$('.toplinks .search-button').trigger('click');
             break;
        }
 	 });
 	 $('#form-search').submit(function(e){
		 e.preventDefault();
        	var $search_val = $(this).find('.search--input').val();
        	$('#morphsearch').find('.morphsearch-input').val($search_val);
        	$('#morphsearch').find('.morphsearch-submit').trigger('click');
        	$('.toplinks .search-button').trigger('click');
	});
}



function loginForm() {
    $('form[name="login_form"]').on('keydown',function(e){
        switch(true){
            case e.keyCode == 13: // ENTER
                $('form[name="login_form"]').submit();
                break;
        }
    });

    $('form[name="login_form"]').addClass('ready');
    $('form[name="login_form"]').validate({
        rules: {
            'email': 'required',
            'password': 'required'
        },
        messages: {
            'email': 'Username is required',
            'password': 'Password is required'
        },
        submitHandler: function () {
            $.ajax({data: $('form[name="login_form"]').serialize(), success: function (data) {
                if (data.status == 'ok'  && typeof(data.redirect) !== 'undefined') {
                    window.location = data.redirect;
                }else if (data.status == 'ok'){
                     window.location = (data.redirect || URL);
                }else if (data.status == 'error') {
                    if (typeof(data.callback) !== 'undefined') {
                        var username = $('form[name="login_form"] input[name="username"]').val();
                        eval(data.callback + '("' + data.error + '","' + username + '")');
                    } else {
                       alert( data.error);
                    }
                } else {
					 alert('An unknown error occurred. Please try again later');
                }

            }});
        }
    });
}


function companiesMap(){
	if($('#figMap').length>0){
		$('#figMap').imageMapResize();
	}
	
}
function filterTranslatedContent($this){
	$('.page-content .translated-content').hide();
	$('.page-content').find($this.data('target')).show();
	$this.closest('.language-triggers').find('.language-trigger').removeClass('active');
	$this.addClass('active');
	return false;
}
		
